export default "__VITE_ASSET__e265f1d1__"